const l = "_label_9qb4x_1", o = {
  label: l,
  "label--zoomed": "_label--zoomed_9qb4x_16",
  "label--color-pink": "_label--color-pink_9qb4x_28",
  "label--color-green": "_label--color-green_9qb4x_33",
  "label--color-brown": "_label--color-brown_9qb4x_38",
  "label--color-gray": "_label--color-gray_9qb4x_43",
  "label--color-blue": "_label--color-blue_9qb4x_48",
  "label--color-yellow": "_label--color-yellow_9qb4x_53"
};
export {
  o as default,
  l as label
};
//# sourceMappingURL=index.es655.js.map
